import api from "./api";

export const getUsers = async (data) => {
  return await api.post(`/api/users/users_report`, data);
};
